import { ChangeEvent, useEffect, useState } from "react";
import { searchCustomer } from "src/apis/customerApi";
import { getItemPopupList } from "src/apis/itemApi";
import { useTQC3020_R01Store, defaultTQC3020_R01Filter, TQC3020_R01_TabType } from "./Store_TQC3020_R01";
import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import useUiuxStore from "src/store/useUiuxStore";
import { WorkPlaceDto } from "src/dtos/workplace/workPlaceDto";


export const SearchSection_TQC3020_R01 = () => {
	const { 
		TQC3020_R01activeTab: activeTab,
		TQC3020_R01Filter, 
		setTQC3020_R01Filter 
	} = useTQC3020_R01Store();
	
	const { setCodeSearchModalProps } = useUiuxStore();
	const { compCdList, workPlaceList, fetchWorkPlaceCdCode } = useCommonCodeStore();

	useEffect(() => {
		if (workPlaceList.length === 0) {
			fetchWorkPlaceCdCode().then();
		}
	}, [workPlaceList.length, fetchWorkPlaceCdCode]);
	
	
	// 달력 팝업 노출 여부 상태
	const [pickerVisible, setPickerVisible] = useState(false);
	const [pickerPosition, setPickerPosition] = useState<{ top: number; left: number }>({ top: 0, left: 0 });
	
	const custInfoHandleFoucsId = 'infoCustInput_search_TQC3020';
	const salesItemCdHandleFocusId = 'salesItemCd_search_TQC3020';
	const productItemCdHandleFocusId = 'productItemCd_search_TQC3020';
	
	// 거래처 코드 입력 핸들러
	const handleCustChange = (e: ChangeEvent<HTMLInputElement>) => {
		setTQC3020_R01Filter({ salesCustomCdCondition: e.target.value });
	};
	
	// Info 폼 코드 검색 필드 설정
	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'salesCustomCdCondition',
			category: '거래처',
			focusId: custInfoHandleFoucsId,
			responseMapping: {
				customCd: 'salesCustomCdCondition',
				customNm: 'salesCustomNm',
			},
			searchFunction: async (searchText: string) => {
				const customerResponse = await searchCustomer(searchText);
				return customerResponse.data.data.find(value => value.customCd === searchText);
			}
		},
		{
			fieldName: 'salesItemCd',
			category: '품목',
			focusId: salesItemCdHandleFocusId,
			responseMapping: {
				itemCd: 'salesItemCd',
				itemNm: 'salesItemNm',
			},
			searchFunction: async (searchText: string) => {
				const itemResponse = await getItemPopupList(searchText, 'all', 'all', 'all');
				return itemResponse.data.data.find(value => value.itemCd === searchText);
			},
			extraFilter: () => ({
				itemCd: TQC3020_R01Filter.salesItemCd,
				itemNm: TQC3020_R01Filter.salesItemNm,
			}),
		},
		{
			fieldName: 'productItemCdCondition',
			category: '품목',
			focusId: productItemCdHandleFocusId,
			responseMapping: {
				itemCd: 'productItemCdCondition',
				itemNm: 'productItemNm',
			},
			searchFunction: async (searchText: string) => {
				const itemResponse = await getItemPopupList(searchText, 'all', 'all', 'all');
				return itemResponse.data.data.find(value => value.itemCd === searchText);
			},
			extraFilter: () => ({
				itemCd: TQC3020_R01Filter.productItemCdCondition,
				itemNm: TQC3020_R01Filter.productItemNm,
			}),
		},
	];
	
	const { getFieldHandlers } = useInfoFormEvents({
		editData: TQC3020_R01Filter,
		setEditData: setTQC3020_R01Filter,
		defaultData: defaultTQC3020_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'TQC3020_R01_search'
	});
	
	// 거래처 입력창 더블클릭 시 거래처 검색 모달 오픈
	const handleCustDoubleClick = async (e: React.MouseEvent<HTMLInputElement>) => {
		e.currentTarget.blur();
		getFieldHandlers('salesCustomCdCondition').onDoubleClick(e);
	};
	
	// 생산공정 옵션 (전체 포함) - 실제로는 공정 코드를 가져와야 함
	
	// UI 렌더링
	return (
		<SearchSectionForm>
				{activeTab === 'sales' ? (
					<>
						{/* 매출기준 필터 */}
						<SearchDropDownForm
							label="사업장"
							value={TQC3020_R01Filter.salesCompCdCondition}
							optionList={compCdList}
							onChangeValue={(value: string) => setTQC3020_R01Filter({ salesCompCdCondition: value })}
						/>
						
						<SearchDateRangeForm
							label="매출기간"
							visible={pickerVisible}
							setVisible={setPickerVisible}
							dateRange={TQC3020_R01Filter.salesDateRange}
							setDateRange={(dateRange) => setTQC3020_R01Filter({ salesDateRange: dateRange })}
							pickerPosition={pickerPosition}
							setPickerPosition={setPickerPosition}
							wrapperOption={{
								titleStyle: "h-[24px] flex items-center truncate shrink-0 w-[60px] min-w-[60px]",
							}}
						/>
						
						<SearchCodeModalForm
							label="거래처"
							value={TQC3020_R01Filter.salesCustomCdCondition}
							valueLabel=""
							handleFoucsId={custInfoHandleFoucsId}
							onChange={handleCustChange}
							onDoubleClick={handleCustDoubleClick}
							onKeyDown={getFieldHandlers('salesCustomCdCondition').onEnterKeyDown}
						/>
						
						<SearchCodeModalForm
							label="품목코드"
							value={TQC3020_R01Filter.salesItemCd}
							valueLabel={TQC3020_R01Filter.salesItemNm}
							handleFoucsId={salesItemCdHandleFocusId}
							onChange={getFieldHandlers('salesItemCd').onChange}
							onDoubleClick={getFieldHandlers('salesItemCd').onDoubleClick}
							onKeyDown={getFieldHandlers('salesItemCd').onEnterKeyDown}
						/>
					</>
				) : (
					<>
						{/* 생산기준 필터 */}
						<SearchDropDownForm
							label="사업장"
							value={TQC3020_R01Filter.productCompCdCondition}
							optionList={compCdList}
							onChangeValue={(value: string) => setTQC3020_R01Filter({ productCompCdCondition: value })}
						/>
						
						<SearchDateRangeForm
							label="생산기간"
							visible={pickerVisible}
							setVisible={setPickerVisible}
							dateRange={TQC3020_R01Filter.productDateRange}
							setDateRange={(dateRange) => setTQC3020_R01Filter({ productDateRange: dateRange })}
							pickerPosition={pickerPosition}
							setPickerPosition={setPickerPosition}
							wrapperOption={{
								titleStyle: "h-[24px] flex items-center truncate shrink-0 w-[80px] min-w-[80px]",
							}}
						/>
						
						<SearchDropDownForm<WorkPlaceDto>
							label="생산공정"
							value={TQC3020_R01Filter.productWorkplaceCdCondition}
							optionList={workPlaceList}
							onChangeValue={(value: string) => setTQC3020_R01Filter({
								productWorkplaceCdCondition: value === 'all' ? '' : value,
							})}
						/>
						
						<SearchCodeModalForm
							label="품목코드"
							value={TQC3020_R01Filter.productItemCdCondition}
							valueLabel={TQC3020_R01Filter.productItemNm}
							handleFoucsId={productItemCdHandleFocusId}
							onChange={getFieldHandlers('productItemCdCondition').onChange}
							onDoubleClick={getFieldHandlers('productItemCdCondition').onDoubleClick}
							onKeyDown={getFieldHandlers('productItemCdCondition').onEnterKeyDown}
						/>
					</>
				)}
			</SearchSectionForm>
	);
};

export default SearchSection_TQC3020_R01;

